import { graphql } from '@graphql/gql';

export const GENERATE_CHAT_TOKEN = graphql(`
  mutation GENERATE_CHAT_TOKEN {
    generateChatToken {
      type
      apiKey
      userId
      token
      expiration
    }
  }
`);
